// Ticket 28: Gift Stats API

const API_BASE = window.location.origin;

export async function fetchProfileGiftStats(userId = 'me', range = 'all') {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/stats/profile/${userId}?range=${range}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  
  if (!res.ok) {
    throw new Error('Failed to fetch profile gift stats');
  }
  
  return res.json();
}

export async function fetchSelfRank(range = 'weekly') {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/stats/self-rank?range=${range}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  
  if (!res.ok) {
    throw new Error('Failed to fetch self rank');
  }
  
  return res.json();
}
